import { GET_REQUEST } from '@helpers/request.js';
import {
  API_HOST_NAME,
  API_POLICY_PATH,
  API_SALES_PORTAL_PERSISTENCE_PATH,
} from '../../env.js';

const PERSISTENCE_ROOT = API_HOST_NAME + API_SALES_PORTAL_PERSISTENCE_PATH;
const POLICY_ROOT = API_HOST_NAME + API_POLICY_PATH;
const structurePaths = {
  datetime: PERSISTENCE_ROOT + '/datetime',
  agentIsLeafNode: PERSISTENCE_ROOT + '/agent-is-leaf-node',
  team: {
    agencyNous: PERSISTENCE_ROOT + '/agency-nous/team',
    dls: PERSISTENCE_ROOT + '/team',
    ps: PERSISTENCE_ROOT + '/team',
    acb: PERSISTENCE_ROOT + '/acb/team',
    tpb: PERSISTENCE_ROOT + '/tpb/team',
  },
  individual: {
    agencyNous: PERSISTENCE_ROOT + '/agency-nous/individual',
    dls: PERSISTENCE_ROOT + '/individual',
    ps: PERSISTENCE_ROOT + '/individual',
    acb: PERSISTENCE_ROOT + '/acb/individual',
    tpb: PERSISTENCE_ROOT + '/tpb/individual',
  },
  summary: {
    agencyNous: PERSISTENCE_ROOT + '/agency-nous/summary',
    dls: PERSISTENCE_ROOT + '/summary',
    ps: PERSISTENCE_ROOT + '/summary',
    acb: PERSISTENCE_ROOT + '/acb/summary',
    tpb: PERSISTENCE_ROOT + '/tpb/summary',
  },
  policies: {
    agencyNous: POLICY_ROOT + '/agency-nous/list',
    dls: POLICY_ROOT + '/list',
    ps: POLICY_ROOT + '/list',
    acb: POLICY_ROOT + '/acb/list',
    tpb: POLICY_ROOT + '/tpb/list',
  },
  policyDetail: {
    allChannel: POLICY_ROOT + '/detail/:detail',
  },
  teamPolicies: PERSISTENCE_ROOT + '/team-policy-list',
};
export const getK2ReportDatetimeListService = ({ type }) =>
  GET_REQUEST(structurePaths.datetime, { type });

export const getAgentIsLeafNodeService = ({ type, datetime, code }) =>
  GET_REQUEST(structurePaths.agentIsLeafNode, { type, datetime, code });

export const getK2ReportGroupListService = ({
  type,
  datetime,
  code,
  page,
  size,
  sort,
  channel = 'agencyNous',
  isTopNode,
  isIndirectHierarchy,
}) => {
  const requestObject = {
    type,
    datetime,
    code,
    page,
    size,
    sort,
    isTopNode: 0,
    isIndirectHierarchy: 0,
  };
  if (channel === 'agencyNous') {
    requestObject.isTopNode = isTopNode ? 1 : 0;
    requestObject.isIndirectHierarchy = isIndirectHierarchy ? 1 : 0;
  }

  switch (channel) {
    case 'agencyNous':
      return GET_REQUEST(structurePaths.team.agencyNous, requestObject);
    case 'dls':
      return GET_REQUEST(structurePaths.team.dls, requestObject);
    case 'ps':
      return GET_REQUEST(structurePaths.team.ps, requestObject);
    case 'acb':
      return GET_REQUEST(structurePaths.team.acb, requestObject);
    case 'tpb':
      return GET_REQUEST(structurePaths.team.tpb, requestObject);
    default:
      return null;
  }
};

export const getK2ReportIndividualListService = ({
  type,
  datetime,
  code,
  codeType,
  page,
  size,
  sort,
  channel = 'agencyNous',
}) => {
  const requestObject = {
    type,
    datetime,
    code,
    codeType,
    page,
    size,
    sort,
  };
  switch (channel) {
    case 'agencyNous':
      return GET_REQUEST(structurePaths.individual.agencyNous, requestObject);
    case 'dls':
      return GET_REQUEST(structurePaths.individual.dls, requestObject);
    case 'ps':
      return GET_REQUEST(structurePaths.individual.ps, requestObject);
    case 'acb':
      return GET_REQUEST(structurePaths.individual.acb, requestObject);
    case 'tpb':
      return GET_REQUEST(structurePaths.individual.tpb, requestObject);
    default:
      return null;
  }
};

export const getK2ReportSummaryService = ({
  type,
  datetime,
  code,
  codeType,
  channel,
  isTopNode,
  isIndirectHierarchy,
}) => {
  const requestObject = {
    type,
    datetime,
    code,
    codeType,
    isTopNode: 0,
    isIndirectHierarchy: 0,
  };
  if (channel === 'agencyNous') {
    requestObject.isTopNode = isTopNode ? 1 : 0;
    requestObject.isIndirectHierarchy = isIndirectHierarchy ? 1 : 0;
  }

  switch (channel) {
    case 'agencyNous':
      return GET_REQUEST(structurePaths.summary.agencyNous, requestObject);
    case 'dls':
      return GET_REQUEST(structurePaths.summary.dls, requestObject);
    case 'ps':
      return GET_REQUEST(structurePaths.summary.ps, requestObject);
    case 'acb':
      return GET_REQUEST(structurePaths.summary.acb, requestObject);
    case 'tpb':
      return GET_REQUEST(structurePaths.summary.tpb, requestObject);
    default:
      return null;
  }
};

export const getPolicyAgentService = ({
  type,
  datetime,
  code,
  codeType,
  page,
  size,
  policySort,
  policyNumber,
  policyStatusCode,
  issuedDateFrom,
  issuedDateTo,
  channel = 'agencyNous',
}) => {
  const requestObject = {
    type,
    datetime,
    code,
    codeType,
    page,
    size,
    sort: policySort,
    policyNumber,
    policyStatusCode,
    issuedDateForm: issuedDateFrom,
    issuedDateTo,
  };
  switch (channel) {
    case 'agencyNous':
      return GET_REQUEST(structurePaths.policies.agencyNous, requestObject);
    case 'dls':
      return GET_REQUEST(structurePaths.policies.dls, requestObject);
    case 'ps':
      return GET_REQUEST(structurePaths.policies.ps, requestObject);
    case 'acb':
      return GET_REQUEST(structurePaths.policies.acb, requestObject);
    case 'tpb':
      return GET_REQUEST(structurePaths.policies.tpb, requestObject);
    default:
      return null;
  }
};

export const getPolicyAgentByIdService = ({ policyId }) =>
  GET_REQUEST(
    structurePaths.policyDetail.allChannel.replace(':detail', policyId),
    {},
  );

export const getTeamPolicyListService = ({
  type,
  datetime,
  code,
  codeType,
  page,
  size,
  policySort,
  policyNumber,
  policyStatusCode,
  issuedDateFrom,
  issuedDateTo,
  channel = 'agencyNous',
  isTopNode,
  isIndirectHierarchy,
  serviceAgentInfo,
}) => {
  const requestObject = {
    type,
    datetime,
    code,
    codeType,
    page,
    size,
    sort: policySort,
    policyNumber,
    policyStatusCode,
    issuedDateForm: issuedDateFrom,
    issuedDateTo,
    isTopNode: 0,
    isIndirectHierarchy: 0,
    serviceAgentInfo,
  };
  if (channel === 'agencyNous') {
    requestObject.isTopNode = isTopNode ? 1 : 0;
    requestObject.isIndirectHierarchy = isIndirectHierarchy ? 1 : 0;
  }
  return GET_REQUEST(structurePaths.teamPolicies, requestObject);
};

export const getPolicyFundValueService = (policyId) => {
  return GET_REQUEST(POLICY_ROOT + '/get-fund-value', {
    policyId,
  });
};
